import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarSearchComponent } from '../../../shared/toolbarSearch/toolbarSearch.component';
import { SpinnerServiceComponent } from '../../../shared/spinner-service/spinner-service.component';

import { ImportarNfseEmitidaComponent } from './importar-nfse-emitida/importar-nfse-emitida.component';
import { PreVisualizarPlanilhaComponent } from './pre-visualizar-planilha/pre-visualizar-planilha.component';

@NgModule({
  declarations: [
    ImportarNfseEmitidaComponent,
    PreVisualizarPlanilhaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    FieldsetModule,
    FileUploadModule,
    TableModule,
    ToolbarModule,
    InputTextModule,
    ToolbarSearchComponent,
    SpinnerServiceComponent
  ],
  exports: [
    ImportarNfseEmitidaComponent,
    PreVisualizarPlanilhaComponent 
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ImportacaoNfseEmitidasModule {}
